export default {
  singleLabel: "Facturation automatique",
  listRouteName: "AutomaticBillingList",
  csvExportFilenamePrefix: 'facturations automatiques',
  hideActionPdfButton: true,
  titleField: 'designation',
  sortBy: 'id',
  sortDesc: true,
  fields: [{
      name: 'start_date',
      label: "Date de début",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'end_date',
      label: "Date de fin",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'nb_bill_lines',
      label: "Nombre de lignes",
      type: 'number',
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      // Séparateur de milliers (espace insécable) : ces volumes se lisent mal sans.
      formatter: (context, value) => (value || value === 0)
        ? Number(value).toLocaleString('fr-FR')
        : null
    },
    {
      name: 'total_billing',
      label: "Total des factures",
      type: 'number',
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value) => value
        ? parseFloat(value).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
        : null
    },
    {
      name: 'total_renting',
      label: "Total des locations",
      type: 'number',
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
      formatter: (context, value) => value
        ? parseFloat(value).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
        : null
    },
    {
      // Génération en tâche de fond (worker Messenger) : seule une facturation « Générée »
      // s'exporte. Colonne d'affichage distincte de `generation_status` : AdminTableSync
      // réécrit chaque champ formaté dans la ligne, et la liste a besoin du statut brut.
      name: 'generation_label',
      label: "Statut",
      type: 'text',
      inList: true,
      sortable: false,
      filterIn: false,
      inCsvExport: false,
      formatter: (context, value, item) => ({
        pending: "En attente",
        running: "Génération en cours",
        done: "Générée",
        failed: "Échec",
      })[item.generation_status] || null
    },
    {
      // Filtre seul : origine de la facture (import MCS vs catalogue Axiloc).
      name: 'from_mcs',
      label: "Origine",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    {
      // Filtre seul : plage de dates sur la période de facturation.
      // Le picker « début » borne start_date (>=), le picker « fin » borne end_date (<=).
      name: 'period',
      label: "Période (date de début / date de fin)",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/AutomaticBilling/config.js